import React from 'react'

export default function PaymentFailedIcon() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 375 280"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Admin"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="-failed" transform="translate(5.000000, 0.000000)">
          <path
            d="M15.6508959,257.735099 C11.7783716,240.819958 18.0582485,222.61685 34.4905263,203.125774 C59.1389424,173.889161 66.7969587,167.233866 55.6081587,137.371225 C44.4193586,107.508583 18.1492726,44.8159483 74.3376015,17.0217149 C130.52593,-10.7725187 159.484825,24.0480779 188.995854,33.3152164 C218.506882,42.5823551 302.515105,65.2929489 334.87184,116.523156 C367.228579,167.753363 340.745304,167.085074 334.87184,205.890468 C328.998379,244.695863 348.313494,257.735099 324.523818,257.735099 C308.664036,257.735099 205.706394,257.735099 15.6508959,257.735099 Z"
            id="Path-2"
            fill="#DFF1F1"
            fillRule="nonzero"
          />
          <polygon
            id="Path-2-Copy"
            fill="#DFF1F1"
            fillRule="nonzero"
            transform="translate(302.054556, 140.709170) scale(-1, 1) translate(-302.054556, -140.709170) "
            points="301.803833 119.742749 296.690776 126.560074 302.808113 128.872142 298.944831 135.233897 303.932558 139.257799 301.803833 144.268237 305.865546 148.745671 302.808113 155.53133 307.418337 161.675592 307.418337 124.906348"
          />
          <rect
            id="Rectangle"
            fill="#B2CECE"
            fillRule="nonzero"
            x="0"
            y="251.271523"
            width="366"
            height="6.46357616"
            rx="3.23178808"
          />
          <rect
            id="Rectangle"
            stroke="#252B4C"
            strokeWidth="2"
            fill="#FFFFFF"
            fillRule="nonzero"
            x="77.5629139"
            y="105.84106"
            width="217.820064"
            height="132.32038"
            rx="14"
          />
          <path
            d="M228.826546,177.026142 L257.11864,181.002337 L257.11864,181.002337 L260.19356,218.552411 L226.085992,222.665712 C224.756971,222.825989 223.549656,221.878535 223.38938,220.549514 C223.371385,220.400302 223.367307,220.249739 223.377199,220.099772 L226.070628,179.266859 C226.158737,177.931112 227.313001,176.919701 228.648749,177.00781 C228.70822,177.011732 228.767526,177.017848 228.826546,177.026142 Z"
            id="Rectangle-Copy-4"
            fill="#DFF1F1"
            fillRule="nonzero"
            opacity="0.406295422"
            transform="translate(241.782752, 199.842927) rotate(-8.000000) translate(-241.782752, -199.842927) "
          />
          <path
            d="M228.349875,176.360566 L259.859809,176.360566 L259.859809,176.360566 L259.859809,218.373811 L228.349875,218.373811 C227.011224,218.373811 225.926034,217.28862 225.926034,215.94997 L225.926034,178.784407 C225.926034,177.445757 227.011224,176.360566 228.349875,176.360566 Z"
            id="Rectangle"
            fill="#A6A9B6"
            fillRule="nonzero"
            transform="translate(242.892921, 197.367189) rotate(-8.000000) translate(-242.892921, -197.367189) "
          />
          <polygon
            id="Rectangle"
            fill="#252B4C"
            fillRule="nonzero"
            opacity="0.106195494"
            transform="translate(241.768476, 189.366347) rotate(-8.000000) translate(-241.768476, -189.366347) "
            points="224.801589 185.326612 258.735364 185.326612 258.735364 193.406082 224.801589 193.406082"
          />
          <polygon
            id="Path-2"
            fill="#FFFFFF"
            fillRule="nonzero"
            points="257.00374 173.875199 251.890683 180.692524 258.00802 183.004592 254.144738 189.366347 259.132465 193.39025 257.00374 198.400687 261.065453 202.878122 258.00802 209.66378 262.618245 215.808042 262.618245 179.038798"
          />
          <path
            d="M64.2322863,238.161439 L309.039244,238.161439 C311.047491,238.161439 312.675497,239.789714 312.675497,241.798293 C312.675497,242.731396 312.316906,243.628803 311.673899,244.304885 C307.94299,248.227701 302.766668,250.448332 297.353437,250.448332 L75.9180931,250.448332 C70.5048616,250.448332 65.3285403,248.227701 61.5976321,244.304885 C60.2135079,242.849566 60.2710284,240.547556 61.7261077,239.163203 C62.4020781,238.52009 63.2993369,238.161439 64.2322863,238.161439 Z"
            id="Rectangle-Copy"
            stroke="#252B4C"
            strokeWidth="2"
            fill="#FFFFFF"
            fillRule="nonzero"
          />
          <rect
            id="Rectangle-Copy-2"
            stroke="#252B4C"
            strokeWidth="2"
            x="82.6869276"
            y="110.566787"
            width="208.37017"
            height="122.868924"
            rx="10"
          />
          <path
            d="M100.786696,184.089966 L133.861326,184.089966 C138.558455,184.089966 142.366231,187.898371 142.366231,192.596276 L142.366231,270.570786 C142.366231,275.529686 138.346912,279.549669 133.388831,279.549669 L101.25919,279.549669 C96.3011096,279.549669 92.2817905,275.529686 92.2817905,270.570786 L92.2817905,192.596276 C92.2817905,187.898371 96.0895665,184.089966 100.786696,184.089966 Z"
            id="Rectangle"
            stroke="#252B4C"
            strokeWidth="2"
            fill="#FFFFFF"
            fillRule="nonzero"
          />
          <path
            d="M186.635533,200.370874 C185.654781,200.373427 184.713735,199.983641 184.022047,199.288328 L182.101147,197.367408 C181.853501,197.117554 181.479075,197.042842 181.154504,197.178519 L178.644852,198.217959 C176.758869,198.998613 174.597085,198.103135 173.815538,196.217507 L172.776108,193.707828 C172.642355,193.382345 172.324952,193.170159 171.973064,193.170986 L169.253537,193.170986 C167.213306,193.168551 165.559978,191.515207 165.557544,189.474954 L165.557544,186.757609 C165.558407,186.406297 165.346684,186.089365 165.021812,185.95566 L162.509951,184.914011 C160.624341,184.132455 159.728872,181.970649 160.509518,180.084647 L161.548948,177.573864 C161.683682,177.249196 161.609079,176.875308 161.360061,176.627211 L159.440265,174.706291 C157.996733,173.262517 157.996733,170.921936 159.440265,169.478162 L161.361165,167.557242 C161.611017,167.309593 161.685727,166.935164 161.550052,166.610589 L160.510623,164.100911 C159.729977,162.214908 160.625446,160.053102 162.511055,159.271546 L165.020707,158.231002 C165.346013,158.097644 165.558223,157.780635 165.557544,157.429054 L165.557544,154.710603 C165.559978,152.670351 167.213306,151.017006 169.253537,151.014571 L171.970855,151.014571 C172.322163,151.015435 172.639092,150.80371 172.772795,150.478834 L173.814433,147.966946 C174.595981,146.081318 176.757765,145.18584 178.643747,145.966494 L181.1534,147.005934 C181.478034,147.140982 181.852098,147.066343 182.100042,146.817045 L184.022047,144.89723 C185.465807,143.453682 187.806363,143.453682 189.250122,144.89723 L191.171023,146.81815 C191.418818,147.067725 191.793063,147.1424 192.117666,147.007039 L194.628423,145.967599 C196.514405,145.186944 198.67619,146.082423 199.457737,147.968051 L200.498271,150.47773 C200.631627,150.803038 200.948633,151.015251 201.300211,151.014571 L204.017528,151.014571 C206.05776,151.017006 207.711088,152.670351 207.713522,154.710603 L207.713522,157.427949 C207.712659,157.779261 207.924382,158.096193 208.249253,158.229897 L210.761115,159.271546 C212.646724,160.053102 213.542193,162.214908 212.761547,164.100911 L211.722118,166.610589 C211.586665,166.934638 211.660901,167.30844 211.9099,167.556137 L213.8308,169.478162 C214.524285,170.171349 214.913907,171.111696 214.913907,172.092226 C214.913907,173.072757 214.524285,174.013103 213.8308,174.706291 L211.9099,176.627211 C211.660882,176.875308 211.58628,177.249196 211.721013,177.573864 L212.760442,180.084647 C213.541088,181.970649 212.645619,184.132455 210.760011,184.914011 L208.250358,185.954556 C207.925052,186.087914 207.712843,186.404922 207.713522,186.756504 L207.713522,189.47385 C207.711088,191.514103 206.05776,193.167447 204.017528,193.169882 L201.300211,193.169882 C200.948322,193.169055 200.630919,193.381241 200.497166,193.706723 L199.457737,196.217507 C198.67619,198.103135 196.514405,198.998613 194.628423,198.217959 L192.117666,197.178519 C191.793063,197.043157 191.418818,197.117833 191.171023,197.367408 L189.249018,199.288328 C188.55733,199.983641 187.616284,200.373427 186.635533,200.370874 Z"
            id="Combined-Shape"
            fill="#A6A9B6"
            fillRule="nonzero"
          />
          <rect
            id="Rectangle-Copy-4"
            stroke="#252B4C"
            strokeWidth="2"
            fill="#FFFFFF"
            fillRule="nonzero"
            x="113.544053"
            y="267.735349"
            width="7.55991546"
            height="7.56116457"
            rx="3.77995773"
          />
          <path
            d="M102.747987,188.232831 L131.900034,188.232831 C135.451556,188.232831 138.330633,191.223136 138.330633,194.911864 L138.330633,259.030579 C138.330633,260.50607 137.179002,261.702193 135.758394,261.702193 L117.324011,261.702193 L98.8896281,261.702193 C97.4690197,261.702193 96.3173881,260.50607 96.3173881,259.030579 L96.3173881,194.911864 C96.3173881,191.223136 99.1964653,188.232831 102.747987,188.232831 Z"
            id="Rectangle-Copy-3"
            stroke="#252B4C"
            strokeWidth="2"
          />
          <path
            d="M117.152217,232.688741 C116.731895,232.689835 116.328589,232.522784 116.032152,232.224793 L115.208909,231.401541 C115.102775,231.294461 114.942307,231.262441 114.803205,231.320588 L113.72764,231.766063 C112.919361,232.100629 111.992883,231.716853 111.657933,230.908726 L111.212463,229.83315 C111.155141,229.693657 111.019111,229.60272 110.868301,229.603075 L109.70279,229.603075 C108.828406,229.602031 108.119836,228.893455 108.118793,228.019061 L108.118793,226.854484 C108.119163,226.703922 108.028425,226.568094 107.889194,226.510792 L106.812681,226.064371 C106.004564,225.729418 105.620791,224.80293 105.955354,223.994644 L106.400824,222.918594 C106.458566,222.77945 106.426594,222.619212 106.319872,222.512886 L105.497102,221.689634 C104.878446,221.070873 104.878446,220.067767 105.497102,219.449007 L106.320345,218.625756 C106.427425,218.519621 106.459444,218.359151 106.401297,218.220047 L105.955827,217.14447 C105.621265,216.336184 106.005037,215.409696 106.813155,215.074744 L107.888721,214.628796 C108.028137,214.571642 108.119084,214.435781 108.118793,214.285103 L108.118793,213.120053 C108.119836,212.245659 108.828406,211.537083 109.70279,211.53604 L110.867355,211.53604 C111.017915,211.536409 111.153743,211.44567 111.211044,211.306438 L111.657461,210.229914 C111.992409,209.421788 112.918888,209.038012 113.727166,209.372578 L114.802731,209.818052 C114.94186,209.87593 115.102173,209.843942 115.208435,209.7371 L116.032152,208.914322 C116.650906,208.295659 117.654001,208.295659 118.272755,208.914322 L119.095998,209.737573 C119.202197,209.844534 119.362587,209.876538 119.501703,209.818526 L120.577742,209.373051 C121.386019,209.038485 122.312499,209.422261 122.647448,210.230388 L123.093391,211.305965 C123.150543,211.445383 123.286403,211.536331 123.437079,211.53604 L124.601644,211.53604 C125.476029,211.537083 126.184598,212.245659 126.185641,213.120053 L126.185641,214.28463 C126.185271,214.435192 126.27601,214.57102 126.415241,214.628322 L127.491752,215.074744 C128.299871,215.409696 128.683643,216.336184 128.34908,217.14447 L127.903611,218.220047 C127.84556,218.358926 127.877375,218.519126 127.984089,218.625282 L128.807332,219.449007 C129.10454,219.746087 129.271521,220.149093 129.271521,220.569321 C129.271521,220.989548 129.10454,221.392553 128.807332,221.689634 L127.984089,222.512886 C127.877367,222.619212 127.845394,222.77945 127.903137,222.918594 L128.348607,223.994644 C128.68317,224.80293 128.299397,225.729418 127.491279,226.064371 L126.415714,226.510318 C126.276297,226.567473 126.18535,226.703333 126.185641,226.854011 L126.185641,228.018587 C126.184598,228.892982 125.476029,229.601558 124.601644,229.602601 L123.437079,229.602601 C123.286269,229.602247 123.15024,229.693184 123.092917,229.832676 L122.647448,230.908726 C122.312499,231.716853 121.386019,232.100629 120.577742,231.766063 L119.501703,231.320588 C119.362587,231.262576 119.202197,231.29458 119.095998,231.401541 L118.272282,232.224793 C117.975845,232.522784 117.572539,232.689835 117.152217,232.688741 Z"
            id="Combined-Shape"
            fill="#A6A9B6"
            fillRule="nonzero"
          />
          <polygon
            id="Path-6"
            fill="#DFF1F1"
            fillRule="nonzero"
            opacity="0.406295422"
            points="294.217809 220.024824 265.079432 220.024824 264.372895 215.68964 283.699129 215.129513"
          />
          <path
            d="M269.555173,176.360566 L301.065107,176.360566 L301.065107,176.360566 L301.065107,218.373811 L269.555173,218.373811 C268.216522,218.373811 267.131332,217.28862 267.131332,215.94997 L267.131332,178.784407 C267.131332,177.445757 268.216522,176.360566 269.555173,176.360566 Z"
            id="Rectangle-Copy-2"
            fill="#A6A9B6"
            fillRule="nonzero"
            transform="translate(284.098219, 197.367189) scale(-1, 1) rotate(-8.000000) translate(-284.098219, -197.367189) "
          />
          <polygon
            id="Rectangle-Copy-3"
            fill="#252B4C"
            fillRule="nonzero"
            opacity="0.106195494"
            transform="translate(285.222664, 189.366347) scale(-1, 1) rotate(-8.000000) translate(-285.222664, -189.366347) "
            points="268.255777 185.326612 302.189551 185.326612 302.189551 193.406082 268.255777 193.406082"
          />
          <polygon
            id="Path-2-Copy-2"
            fill="#FFFFFF"
            fillRule="nonzero"
            transform="translate(269.736676, 194.841621) scale(-1, 1) translate(-269.736676, -194.841621) "
            points="269.485953 173.875199 264.372895 180.692524 270.490232 183.004592 266.626951 189.366347 271.614677 193.39025 269.485953 198.400687 273.547665 202.878122 270.490232 209.66378 275.100457 215.808042 275.100457 179.038798"
          />
          <path
            d="M281.60606,207.325363 L294.149107,207.325363 C294.701392,207.325363 295.149107,207.773078 295.149107,208.325363 L295.149107,213.596886 C295.149107,214.149171 294.701392,214.596886 294.149107,214.596886 L281.60606,214.596886 C281.053776,214.596886 280.60606,214.149171 280.60606,213.596886 L280.60606,208.325363 C280.60606,207.773078 281.053776,207.325363 281.60606,207.325363 Z"
            id="Rectangle"
            fill="#FFFFFF"
            fillRule="nonzero"
            transform="translate(287.877584, 210.961124) rotate(9.000000) translate(-287.877584, -210.961124) "
          />
          <line
            x1="179.364238"
            y1="164.013245"
            x2="193.907285"
            y2="179.828005"
            id="Path-5"
            stroke="#FFFFFF"
            strokeWidth="3"
            strokeLinecap="round"
          />
          <line
            x1="179.364238"
            y1="164.013245"
            x2="193.907285"
            y2="179.828005"
            id="Path-5-Copy"
            stroke="#FFFFFF"
            strokeWidth="3"
            strokeLinecap="round"
            transform="translate(186.635762, 171.920625) scale(-1, 1) translate(-186.635762, -171.920625) "
          />
          <line
            x1="114.728477"
            y1="217.337748"
            x2="120.384106"
            y2="223.801325"
            id="Path-5"
            stroke="#FFFFFF"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <line
            x1="114.728477"
            y1="217.337748"
            x2="120.384106"
            y2="223.801325"
            id="Path-5-Copy"
            stroke="#FFFFFF"
            strokeWidth="2"
            strokeLinecap="round"
            transform="translate(117.556291, 220.569536) scale(-1, 1) translate(-117.556291, -220.569536) "
          />
          <polygon
            id="Path-7"
            fill="#DFF1F1"
            fillRule="nonzero"
            points="87.5399656 98.8754518 101.153965 118.458788 109.393289 118.458788 114.728477 126.931235 120.384106 126.931235 127.012373 135.717806 124.300332 120.53714 117.705763 120.53714 113.544053 112.91421 105.03311 112.91421 99.8777141 96.8573561"
          />
          <polygon
            id="Path-7-Copy"
            fill="#FFFFFF"
            fillRule="nonzero"
            transform="translate(217.361307, 66.234280) rotate(120.000000) translate(-217.361307, -66.234280) "
            points="167.213749 25.4434654 205.783267 69.1918 220.001471 69.1918 229.208146 83.8122937 238.967793 83.8122937 267.508864 110.507626 245.725835 72.7783125 234.345906 72.7783125 227.164244 59.623789 212.47732 59.623789 188.504407 21.9609344"
          />
        </g>
      </g>
    </svg>
  )
}
